export const templateData = {
  INDIVIDUAL: [
    {
      index: 0,
      minutes: 0,
      type: 'individual',
    },
    {
      index: 1,
      minutes: 0,
      type: 'individual',
    },
    {
      index: 2,
      minutes: 0,
      type: 'individual',
    },
    {
      index: 3,
      minutes: 0,
      type: 'individual',
    },
    {
      index: 4,
      minutes: 0,
      type: 'individual',
    },
    {
      index: 5,
      minutes: 0,
      type: 'individual',
    },
    {
      index: 6,
      minutes: 0,
      type: 'individual',
    },
  ],
  CONCURRENT: [
    {
      index: 0,
      minutes: 0,
      type: 'concurrent',
    },
    {
      index: 1,
      minutes: 0,
      type: 'concurrent',
    },
    {
      index: 2,
      minutes: 0,
      type: 'concurrent',
    },
    {
      index: 3,
      minutes: 0,
      type: 'concurrent',
    },
    {
      index: 4,
      minutes: 0,
      type: 'concurrent',
    },
    {
      index: 5,
      minutes: 0,
      type: 'concurrent',
    },
    {
      index: 6,
      minutes: 0,
      type: 'concurrent',
    },
  ],
  GROUP: [
    {
      index: 0,
      minutes: 0,
      type: 'group',
    },
    {
      index: 1,
      minutes: 0,
      type: 'group',
    },
    {
      index: 2,
      minutes: 0,
      type: 'group',
    },
    {
      index: 3,
      minutes: 0,
      type: 'group',
    },
    {
      index: 4,
      minutes: 0,
      type: 'group',
    },
    {
      index: 5,
      minutes: 0,
      type: 'group',
    },
    {
      index: 6,
      minutes: 0,
      type: 'group',
    },
  ],
};

export const templateData1 = {
  MONDAY: {
    GROUP: 3,
    CONCURRENT: 2,
    INDIVIDUAL: 1,
  },
  TUESDAY: {
    GROUP: 2,
    CONCURRENT: 2,
    INDIVIDUAL: 2,
  },
  WEDNESDAY: {
    GROUP: 1,
    CONCURRENT: 3,
    INDIVIDUAL: 1,
  },
  THURSDAY: {
    GROUP: 3,
    CONCURRENT: 1,
    INDIVIDUAL: 2,
  },
  FRIDAY: {
    GROUP: 2,
    CONCURRENT: 2,
    INDIVIDUAL: 2,
  },
  SATURDAY: {
    GROUP: 1,
    CONCURRENT: 1,
    INDIVIDUAL: 1,
  },
  SUNDAY: {
    GROUP: 12,
    CONCURRENT: 12,
    INDIVIDUAL: 12,
  },
};
